import { RoomSession } from '../../../../../models/Room'
import React from 'react'
import { useChangePrivacyOption } from '../../../../../views/LiveMeetings/AdditionalOptions'
import { useReloadRoomSession } from '../../MeetingPreparation/hooks/api'
import { CustomDropdownItemOption, DropDownItemOptionComponentProps, SelectDropdown } from '../../../../../components/SelectDropdown/SelectDropdown'
import classNames from 'classnames'
import { useAppSelector } from '../../../../../store/hooks'
import { selectSafeAuthenticatedUser } from '../../../../../store/auth/authSlice'

interface PrivacyControlProps {
  session: RoomSession
}

export const PrivacyControl: React.FC<PrivacyControlProps> = ({ session }) => {
  const reloadRoomSession = useReloadRoomSession()
  const { resultOption: changePrivacyOption, isLoading: changePrivacyLoading } = useChangePrivacyOption(session, reloadRoomSession)
  const { id: currentUserId } = useAppSelector(selectSafeAuthenticatedUser)

  const PrivacyDropdownItemOption: React.FC<DropDownItemOptionComponentProps> = ({ displayLabel, disabled, onClick }) => {
    if (!changePrivacyOption) {
      return null
    }
    const { icon } = changePrivacyOption
    return (
      <CustomDropdownItemOption
        role='button'
        onClick={onClick}
        className={classNames('d-flex gap-2 align-items-center', { 'dropdown-item-disabled': disabled })}
      >
        <i className={`bi ${icon} fs-6`} />
        {displayLabel}
      </CustomDropdownItemOption>
    )
  }

  return (
    changePrivacyOption && (
      <SelectDropdown
        className='zocks-py-0.125 px-2 zocks-border-0.25 zocks-border-primary-light'
        options={[changePrivacyOption.selectOption]}
        icon={session.isPrivate ? 'bi-lock' : 'bi-unlock'}
        initialSelectedOption={{ id: '', label: session.isPrivate ? 'Private' : 'Public' }}
        hideArrows
        onOptionSelected={changePrivacyOption.handleSelected}
        DropDownItemOptionComponent={PrivacyDropdownItemOption}
        disabled={currentUserId !== session.roomCreatedBy?.id}
        loading={changePrivacyLoading}
      />
    )
  )
}
